import { formatEntityName, formatFieldName } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
export const renameFieldStmtInstruction = `
#### Rename field
- Description: Renames any field in an entity. Field can be a column or a relation or even plugin.
- Syntax: \`rename field <entity_name>.<field_name> <new_field_name>;\`
- Example: \`rename field Car.weigth weight;\``;
export const stmtRenameField = ({ entityName, fieldName, newFieldName }) => {
    return `rename field ${entityName}.${fieldName} ${newFieldName};`;
};
export const stmtForHumanRenameField = ({ entityName, fieldName, newFieldName }) => {
    return `Rename the field __${fieldName}__ in the entity __${entityName}__ to __${newFieldName}__.`;
};
export const renameFieldHandler = createSchemaStatementHandler({
    type: 'rename field',
    parse: line => {
        const match = /^rename (field|column|relation) (?<entityName>\w+)\.(?<fieldName>\w+) (?<newFieldName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'rename field',
                entityName: formatEntityName(match.groups.entityName),
                fieldName: formatFieldName(match.groups.fieldName),
                newFieldName: formatFieldName(match.groups.newFieldName),
            }
            : null;
    },
    getHumanStmt: stmtForHumanRenameField,
    apply: (stmt, builder) => {
        builder.updateSchema(it => it.updateFieldName(stmt.entityName, stmt.fieldName, stmt.newFieldName));
    },
});
//# sourceMappingURL=RenameFieldStmt.js.map